import { PayloadAction } from '@reduxjs/toolkit';
import { IOperatorRegionalOffice } from 'interfaces/operatorRegionalOffice';
import { PageResult } from 'interfaces/pageResult';
import { getAllOperatorRegionalOffice } from 'redux/action/operatorRegionalOffice';

import { StateData } from '../../interfaces/stateData';
import createAsyncReducer from '../createAsyncReducer';
import { createAsyncSlice } from '../createAsyncSlice';
import { RootState } from '../rootState';

export const operatorRegionalOfficeSlice = createAsyncSlice<StateData<IOperatorRegionalOffice>>({
  name: 'operatorRegionalOffice',
  initialData: {
    list: [],
    totalCount: 0
  },
  reducers: {},
  extraReducers: (builder) => {
    createAsyncReducer(
      builder,
      getAllOperatorRegionalOffice,
      (state, { payload }: PayloadAction<PageResult<IOperatorRegionalOffice>>) => {
        state.isFetching = false;
        state.isSuccess = true;
        state.data.list = payload.content;
        state.data.totalCount = payload.totalElements;
      }
    );
  }
});

export const operatorRegionalOfficeSelector = (state: RootState) => state.operatorRegionalOfficeSlice;
export const operatorRegionalOfficeTotalCountSelector = (state: RootState) => state.operatorRegionalOfficeSlice.data.totalCount;
export const operatorRegionalOfficesDataSelector = (state: RootState) => state.operatorRegionalOfficeSlice.data.list;
export const operatorRegionalOfficeDataSelector = (state: RootState) => state.operatorRegionalOfficeSlice.data.entry;

export const { clearState } = operatorRegionalOfficeSlice.actions;
